import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { get } from '../helpers/Api'
import SearchComponent from '../searchitems'
import { useSharedState } from '../waxplorer/Waxplorer'

export const PFPView = (props) => {
    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const [PFPs, setPFPs] = useState(null)

    const parsePFPs = (res) => {
        setPFPs(res)
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            get(`pfps/*`, 'legacy').then(parsePFPs)
        }
    }, [])

    const bgTransparent = cn('pt-12 bg-transparent h-auto')

    return (
        <div className="relative">
            {PFPs && Object.keys(PFPs).length > 0 ? (
                <SearchComponent
                    {...props}
                    className={bgTransparent}
                    listType={'pfpranking'}
                    searchSettings={{
                        search_type: {
                            value: 'pfps',
                            fixed: false,
                        },
                        order_by: {
                            value: 'rarity_score_desc',
                            fixed: false,
                        },
                        minimal: false,
                        tab: 'pfp',
                        limit: {
                            value: 60,
                            fixed: true,
                        },
                        displayCollectionSelector: false,
                        collection: {
                            value: Object.keys(PFPs)[0],
                            fixed: false,
                        },
                        pfps_only: {
                            value: true,
                            fixed: true,
                        },
                        schema: {
                            value: PFPs[Object.keys(PFPs)[0]][0],
                            fixed: false,
                            options: PFPs,
                        },
                        expanded: false,
                    }}
                    pfps={PFPs}
                    limit={60}
                    tab={'pfps'}
                    userName={userName}
                />
            ) : (
                ''
            )}
        </div>
    )
}
